import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isAvatarPopupOpen: false,
  isProfilePopupOpen: false,
  isPlacePopupOpen: false,
  isBulkPopupOpen: false,
  isFileUploadPopupOpen: false,
  isImagePopupOpen: false,
  isConfirmationPopupOpen: false,
  isCheckoutPopupOpen: false,
  isInfoToolTipPopupOpen: false,
  isInstructionsPopupOpen: false,
  editButtonsVisible: false,
  smallPrintCounterSum: 0,
  bigPrintCounterSum: 0,
  digitalOptionCounterSum: 0,
  yearbookOptionCounterSum: 0,
  toolTipPicture: 'success',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsAvatarPopupOpen(state, action) {
      state.isAvatarPopupOpen = action.payload;
    },
    setIsProfilePopupOpen(state, action) {
      state.isProfilePopupOpen = action.payload;
    },
    setIsPlacePopupOpen(state, action) {
      state.isPlacePopupOpen = action.payload;
    },
    setIsBulkPopupOpen(state, action) {
      state.isBulkPopupOpen = action.payload;
    },
    setIsFileUploadPopupOpen(state, action) {
      state.isFileUploadPopupOpen = action.payload;
    },
    setIsImagePopupOpen(state, action) {
      state.isImagePopupOpen = action.payload;
    },
    setIsConfirmationPopupOpen(state, action) {
      state.isConfirmationPopupOpen = action.payload;
    },
    setIsCheckoutPopupOpen(state, action) {
      state.isCheckoutPopupOpen = action.payload;
    },
    setIsInfoToolTipPopupOpen(state, action) {
      state.isInfoToolTipPopupOpen = action.payload;
    },
    setIsInstructionsPopupOpen(state, action) {
      state.isInstructionsPopupOpen = action.payload;
    },
    setEditButtonsVisible(state, action) {
      state.editButtonsVisible = action.payload;
    },
    setSmallPrintCounterSum(state, action) {
      state.smallPrintCounterSum = action.payload;
    },
    setBigPrintCounterSum(state, action) {
      state.bigPrintCounterSum = action.payload;
    },
    setDigitalOptionCounterSum(state, action) {
      state.digitalOptionCounterSum = action.payload;
    },
    setYearbookOptionCounterSum(state, action) {
      state.yearbookOptionCounterSum = action.payload;
    },
    setToolTipPicture(state, action) {
      state.toolTipPicture = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setIsAvatarPopupOpen,
  setIsProfilePopupOpen,
  setIsPlacePopupOpen,
  setIsBulkPopupOpen,
  setIsFileUploadPopupOpen,
  setIsImagePopupOpen,
  setIsConfirmationPopupOpen,
  setIsCheckoutPopupOpen,
  setIsInfoToolTipPopupOpen,
  setIsInstructionsPopupOpen,
  setEditButtonsVisible,
  setSmallPrintCounterSum,
  setBigPrintCounterSum,
  setDigitalOptionCounterSum,
  setYearbookOptionCounterSum,
  setToolTipPicture,
} = uiSlice.actions;
export default uiSlice.reducer;